/* Schéma storytelling « scrollytelling » (sections/product-story-scroll.liquid).
   SYNCHRO 1 ÉTAPE = 1 PALIER : l'illustration centrale se cale sur l'ÉTAPE ACTIVE
   (celle la plus proche du centre de l'écran) — 4 étapes = 4 positions/couleurs.
   Elle avance/change de teinte d'un cran quand le texte change d'étape (transitions
   CSS douces). Progressive enhancement : sans JS, dernier stade lisible (CSS).
   Respecte « prefers-reduced-motion » (aucune animation liée au scroll). */

const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const clamp = (v) => (v < 0 ? 0 : v > 1 ? 1 : v);

function initStory(root) {
  if (root.dataset.storyInit === '1') return;
  root.dataset.storyInit = '1';

  const steps = Array.prototype.slice.call(root.querySelectorAll('[data-story-step]'));
  const n = steps.length;
  if (n === 0) return;

  // Fondu enchaîné : chaque stade s'efface quand le suivant apparaît (pour un sujet
  // AJOURÉ comme les filaments de safran, sinon les couches du dessous transparaissent).
  // Désactivé par défaut = superposition additive (sujets opaques qui se recouvrent, ex. citron).
  const crossfade = root.hasAttribute('data-story-crossfade');
  // Mode « ambiance » : une grande image de fond pleine largeur qui suit l'étape active.
  const ambiance = root.classList.contains('story-scroll--ambiance');
  // Mobile (tout storytelling) : l'illustration (décalée à droite) est CALÉE sur l'étape active
  // par le JS — elle glisse d'une étape à l'autre pour rester pile à son niveau, sans espace vide
  // en haut (le CSS ne peut pas suivre l'étape active ; sur desktop c'est la colonne sticky qui
  // s'en charge). On mesure le haut par rapport au véritable offsetParent du sujet.
  const fruit = root.querySelector('.story-scroll__fruit');
  // Nombre de STADES d'illustration : 4 si un stade intermédiaire (mid2) est présent
  // (ex. safran : bulbe → crocus → cueillette → pistils), sinon 3. Le fondu enchaîné est
  // « triangulaire » : chaque stade culmine à SON étape (aligné sur le nombre d'étapes).
  const hasMid2 = !!root.querySelector('.story-scroll__img--mid2');

  // Mouvement réduit : état final figé (le CSS s'en charge), toutes les étapes visibles.
  if (REDUCE) {
    steps.forEach((s) => s.classList.add('is-in'));
    return;
  }

  let ticking = false;
  const update = () => {
    ticking = false;
    // Étape ACTIVE = celle dont le centre est le plus proche du centre de l'écran.
    const viewCenter = window.innerHeight * 0.5;
    let active = 0;
    let best = Infinity;
    for (let i = 0; i < n; i++) {
      const r = steps[i].getBoundingClientRect();
      const center = r.top + r.height / 2;
      const dist = Math.abs(center - viewCenter);
      if (dist < best) {
        best = dist;
        active = i;
      }
    }
    // Position normalisée 0 → 1 par PALIER (0, 1/3, 2/3, 1 pour 4 étapes).
    const pos = n > 1 ? active / (n - 1) : 0;
    root.style.setProperty('--pos', pos.toFixed(3));
    if (crossfade) {
      // Fondu enchaîné TRIANGULAIRE : chaque stade culmine (opacité 1) pile à son étape et
      // s'efface linéairement sur un palier de part et d'autre → un seul sujet plein par
      // étape. Générique : 3 stades (start/mid/end, positions 0-½-1) OU 4 stades
      // (start/mid/mid2/end, positions 0-⅓-⅔-1, ex. safran avec la cueillette). Le nombre de
      // stades s'aligne sur le nombre d'étapes (défini par les gabarits).
      var k = hasMid2 ? 4 : 3;
      var sw = 1 / (k - 1);
      var tri = function (peak) { return clamp(1 - Math.abs(pos - peak) / sw); };
      root.style.setProperty('--start', tri(0).toFixed(3));
      root.style.setProperty('--mid', tri(sw).toFixed(3));
      if (hasMid2) {
        root.style.setProperty('--mid2', tri(2 * sw).toFixed(3));
      }
      root.style.setProperty('--end', tri(1).toFixed(3));
    } else {
      // Superposition additive (comportement d'origine, sujets opaques ex. citron).
      root.style.setProperty('--mid', clamp(pos * 1.6).toFixed(3)); // vert → marron
      root.style.setProperty('--end', clamp((pos - 0.45) / 0.4).toFixed(3)); // marron → noir
    }
    // Ambiance : la grande image de fond suit l'étape active.
    if (ambiance) {
      const d = steps[active].getAttribute('data-decor');
      if (d) root.style.setProperty('--decor-band', 'url(' + d + ')');
    }
    // Caler le sujet sur l'étape active (toutes largeurs) : il glisse d'une étape à l'autre pour
    // rester à son niveau, à droite du texte. On mesure le HAUT par rapport au véritable
    // offsetParent du sujet (son bloc conteneur), pas la section — sinon on décalerait de la
    // hauteur de l'intro. Le centre du sujet coïncide alors avec le centre de l'étape.
    if (fruit) {
      const op = fruit.offsetParent || root;
      const opTop = op.getBoundingClientRect().top;
      const sr = steps[active].getBoundingClientRect();
      const topInOP = sr.top - opTop + sr.height / 2 - fruit.offsetHeight / 2;
      fruit.style.top = Math.round(topInOP) + 'px';
    }
    // Étapes franchies = mises en avant (les suivantes restent estompées).
    for (let i = 0; i < n; i++) steps[i].classList.toggle('is-in', i <= active);
  };
  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

function initAll(scope) {
  (scope || document).querySelectorAll('[data-story-scroll]').forEach(initStory);
}

initAll();

// Éditeur de thème : ré-initialiser à l'ajout/rechargement de la section.
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
